import AiSecurityExperience from '@comp/ai/ai-security-experience'

export default function AgentApprovalsPage({ locale }: { locale: string }) {
  return <AiSecurityExperience page="approvals" locale={locale} />
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
